import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { Dialog } from "primereact/dialog";
import {
  postCallbackPaymentLink,
  postCustomerTransaction,
  postCustomerTransactionStatusCheck,
} from "../../../services/paymentMode/paymentMode";
import { Button } from "primereact/button";
import FinanceAdminMenu from "../../FinanceAdminMenu";
import AdminMenu from "../../AdminMenu";

const CustomerPaymentStatusCheck = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [loading, setLoading] = useState(false);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [transactionList, setTransactionList] = useState([]);
  const [displayUpdateModal, setDisplayUpdateModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [updateStatusValue, setUpdateStatusValue] = useState("success");
  const [submitButtonStatusCheckPressed, setSubmitButtonStatusCheckPressed] =
    useState(false);

  const statusOptions = [
    { name: "INITIATED", value: "initiated" },
    { name: "PROCESSING", value: "processing" },
    { name: "SUCCESS", value: "success" },
    { name: "FAILED", value: "failed" },
    { name: "CANCELED", value: "canceled" },
    { name: "EXPIRED", value: "expired" },
  ];

  const updateStatusOptions = [
    { name: "SUCCESS", value: "success" },
    { name: "FAILED", value: "failed" },
  ];

  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0].value);

  const extractTransactionList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.result)) return payload.result;
    if (Array.isArray(payload?.transactions)) return payload.transactions;
    return [];
  };

  const fetchAllBrands = useCallback(
    (brandState = brandId) => {
      setLoading(true);
      const data = {
        brandId: brandState,
        statusIn: [selectedStatus],
        // linkType: ["SUBSCRIPTION_LINK"]
      };
      postCustomerTransaction(data)
        .then((response) => {
          const Res = response?.data ?? {};
          setTransactionList(extractTransactionList(Res));
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error:", err);
          setLoading(false);
        });
    },
    [selectedStatus, brandId],
  );

  useEffect(() => {
    fetchAllBrands(brandId);
    // fetchTimeSlot(state);
  }, [fetchAllBrands, brandId]);

  const handleOpenUpdateModal = (transaction) => {
    setSelectedTransaction(transaction);
    setUpdateStatusValue("success");
    setDisplayUpdateModal(true);
  };

  const handleCustomerTransactionStatusCheck = (transaction) => {
    if (!transaction?.transactionId) {
      errorMessage("Transaction ID is missing for this transaction.");
      return;
    }

    const payload = {
      ...transaction,
    };

    setSubmitButtonStatusCheckPressed(true);

    postCustomerTransactionStatusCheck(payload)
      .then((response) => {
        const message =
          response?.data?.message || "Transaction status updated.";
        if (response?.data?.status || response?.data?.error === false) {
          successMessage(message);
        } else {
          errorMessage(message);
        }
        setSubmitButtonStatusCheckPressed(false);
        fetchAllBrands(brandId);
      })
      .catch((err) => {
        console.error("Error:", err);
        errorMessage("Unable to update transaction status.");
        setSubmitButtonStatusCheckPressed(false);
      });
  };

  const handleUpdateTransactionStatus = () => {
    if (!selectedTransaction?.transactionId) {
      errorMessage("Transaction ID is missing for this transaction.");
      return;
    }

    const payload = {
      responseCode: updateStatusValue === "success" ? "0000" : "failed",
      invoiceNo: selectedTransaction.transactionId,
    };

    setSubmitButtonPressed(true);

    postCallbackPaymentLink(payload)
      .then((response) => {
        const message =
          response?.data?.message || "Transaction status updated.";
        if (response?.data?.status || response?.data?.error === false) {
          successMessage(message);
        } else {
          errorMessage(message);
        }
        setDisplayUpdateModal(false);
        setSubmitButtonPressed(false);
        fetchAllBrands(brandId);
      })
      .catch((err) => {
        console.error("Error:", err);
        errorMessage("Unable to update transaction status.");
        setSubmitButtonPressed(false);
      });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    navigate("/customer-payment-settlement");
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Customer Online Payment
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mt-6 mb-3 mx-4 flex-1 flex flex-row">
        <div className=" flex-1">
          <FloatLabel>
            <Dropdown
              id="selectedStatus"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              options={statusOptions}
              optionLabel="name"
              placeholder="Status Selection"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            <label
              htmlFor="selectedStatus"
              className="text-md"
              style={{ color: "blue" }}
            >
              Status Selection <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      {loading ? (
        <div style={{ flex: 1 }}>
          <div className="text-center">
            <ProgressSpinner
              style={{ width: "70px", height: "70px" }}
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration="2s"
            />
          </div>
        </div>
      ) : (
        !selectedStatus && (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">Please Select Status</p>
          </div>
        )
      )}

      {selectedStatus && (
        <div className="px-3 pb-5">
          <div className="card shadow-sm mt-4">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped table-bordered mb-0">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>#</th>
                      <th>Created At</th>
                      <th>Link Type</th>
                      <th>Amount</th>
                      <th>Customer Name</th>
                      <th>Customer Mobile</th>
                      <th>Status</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {transactionList.length > 0 ? (
                      transactionList.map((transaction, index) => (
                        <tr
                          key={
                            transaction?.id || transaction?.invoiceNo || index
                          }
                        >
                          <td>{index + 1}</td>
                          <td>
                            {formatDate(transaction?.createdDate) || "N/A"}
                          </td>
                          <td>{transaction?.linkType || "N/A"}</td>
                          <td>{transaction?.amount || "N/A"}</td>
                          <td>{transaction?.customerName || "N/A"}</td>
                          <td>{transaction?.customerMobile || "N/A"}</td>
                          <td>
                            <span className="badge bg-info text-dark text-uppercase">
                              {transaction?.status || "N/A"}
                            </span>
                          </td>

                          {/* <td>
                              {transaction?.status === "initiated" && (
                                <Button
                                  size="sm"
                                  variant="primary"
                                  onClick={() =>
                                    handleOpenUpdateModal(transaction)
                                  }
                                >
                                  Update Status
                                </Button>
                              )}
                            </td> */}
                          <td>
                            {transaction?.status === "initiated" && transaction?.secureHash !== null && !submitButtonStatusCheckPressed ? (
                              <span
                                className="badge text-white text-uppercase py-2 cursor-pointer"

                                style={
                                  {
                                    backgroundColor:"#166534"
                                  }
                                }
                                onClick={() =>
                                  handleCustomerTransactionStatusCheck(
                                    transaction,
                                  )
                                }
                                 
                              >
                                 Check Status
                              </span>
                            ) : <span
                                className="badge text-white text-uppercase py-2"

                                style={
                                  {
                                    backgroundColor:"#166534"
                                  }
                                }
                              >
                                 No Action
                              </span>}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          No transactions found for this status.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <Dialog
        header="Update Transaction Status"
        visible={displayUpdateModal}
        onHide={() => setDisplayUpdateModal(false)}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "35vw" }}
      >
        <div className="p-2">
          <div className="mb-3">
            <label className="form-label">Transaction ID</label>
            <InputText
              value={selectedTransaction?.transactionId || ""}
              disabled
              style={{ width: "100%" }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Update Status</label>
            <Dropdown
              value={updateStatusOptions.find(
                (option) => option.value === updateStatusValue,
              )}
              options={updateStatusOptions}
              optionLabel="name"
              onChange={(e) => setUpdateStatusValue(e.target.value.value)}
              placeholder="Select Status"
              style={{ width: "100%" }}
            />
          </div>

          <div className="text-center">
            <Button
              type="button"
              onClick={handleUpdateTransactionStatus}
              disabled={submitButtonPressed}
              variant="primary"
            >
              {submitButtonPressed ? "Updating..." : "Submit"}
            </Button>
          </div>
        </div>
      </Dialog>

      {userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <AdminMenu setVisible={setVisible} visible={visible} />
      )}
    </div>
  );
};

export default CustomerPaymentStatusCheck;
